import React from 'react';
import { AdSlotProps, AdSlot as DefaultAdSlot } from 'react-dfp';
import { parseScreenType } from '../../common/helpers/utility/screenHelper';
import { getAdPlatformType } from '../../common/helpers/ads/AdsHelper';

const AdSlot: React.FC<AdSlotProps> = ({
  targetingArguments = {},
  sizes = [[0, 0]],
  sizeMapping = [],
  adUnit = '',
}) => {
  const {
    location: { href, origin },
  } = window;
  const subProps = {
    sizes,
    sizeMapping,
    targetingArguments: {
      ...targetingArguments,
      url: origin,
      ref: decodeURI(href),
      platform: getAdPlatformType(parseScreenType()),
    },
  };

  return <DefaultAdSlot data-test={'ad-slot'} {...subProps} adUnit={adUnit} />;
};

export default AdSlot;
